// 文化考核
const curseAdminRouter =
{
  path: '/agent',
  name: 'Agent',
  redirect: '/agent',
  meta: {
    title: '课程管理'
  },
  component: () => import('@/views/agent/agentBase.vue'),
  children:
    [
      // 课程管理首页
      {
        path: '/',
        name: 'CurseIndex',
        component: () => import('@/views/agent/curse/index.vue'),
        meta: { title: '课程管理', hideFoot: true, hideIM: true, menuIndex: 0 }
      },
      // 课程日志页
      {
        path: 'curseLog',
        name: 'CurseLog',
        component: () => import('@/views/agent/curse/lcurseLog.vue'),
        meta: { title: '课程管理日志', hideFoot: true, hideIM: true, menuIndex: 0 }
      },
      // 订单管理首页
      {
        path: 'omIndex',
        name: 'OmIndex',
        component: () => import('@/views/agent/order/index.vue'),
        meta: { title: '订单管理', hideFoot: true, hideIM: true, menuIndex: 1 }
      }
    ]
}
export default curseAdminRouter
